module.exports = __webpack_public_path__ + "img/login-merchant.020134a4.jpg";